export enum IvrStatusEnum {
  NONE = 0,
  OPT_IN = 1,
  OPT_OUT = 2,
}



// WEBPACK FOOTER //
// ./src/app/core/enums/reminders.enum.ts